import { AppSectionErrorBoundary } from 'components/ui';
import { AppSpacer } from 'components/ui';
import ProductUpdatesSection from './components/ProductUpdatesSection';
import SupportSection from './components/SupportSection';
import UserManagementSection from './components/UserManagementSection';
import { observer } from 'mobx-react-lite';
import { t } from 'utilities/TranslationUtils';
import { useStores } from 'index';

export const HomePage = observer(() => {
  const { profileStore } = useStores();

  return (
    <div>
      <h1 className='text-center font-500 font-25 mb-0'>{t('common.hello') + ' ' + (profileStore.firstName || '')}</h1>
      <AppSpacer space='42px' />

      <div className='row'>
        <div className='col-12 col-md-6'>
          <AppSectionErrorBoundary>
            <SupportSection />
          </AppSectionErrorBoundary>
        </div>
        <div className='col-12 col-md-6'>
          <AppSectionErrorBoundary>
            <UserManagementSection organizationAdmins={profileStore.organizationAdmins} />
          </AppSectionErrorBoundary>
        </div>
      </div>

      {!profileStore.isPlayer() && (
        <AppSectionErrorBoundary>
          <ProductUpdatesSection />
        </AppSectionErrorBoundary>
      )}
    </div>
  );
});

export default HomePage;
